import { render, staticRenderFns } from "./CCMDesign.vue?vue&type=template&id=12f17170&scoped=true&"
import script from "./CCMDesign.vue?vue&type=script&lang=js&"
export * from "./CCMDesign.vue?vue&type=script&lang=js&"
import style0 from "./CCMDesign.vue?vue&type=style&index=0&id=12f17170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f17170",
  null
  
)

export default component.exports